/**
 * Application constants and configuration
 * Centralized configuration for easy maintenance and environment-specific values
 */

// Contact Information
export const CONTACT = {
  email: process.env.REACT_APP_CONTACT_EMAIL || 'mahasyed03@hotmail.com',
  linkedin: process.env.REACT_APP_LINKEDIN_URL || 'https://www.linkedin.com/in/mahanoor-syed-8bb55b1ab',
  github: process.env.REACT_APP_GITHUB_URL || 'https://github.com/mahasch',
};

// Application Metadata
export const APP_METADATA = {
  title: 'Mahanoor Syed - Portfolio',
  description: 'Electronic and Information Engineering Graduate | Imperial College London | Founder of Tutortap Tuition',
  author: 'Mahanoor Syed',
  keywords: 'Mahanoor Syed, Portfolio, Software Engineer, Full Stack Developer, Machine Learning, IoT, React, Angular',
};

// CV Configuration
export const CV_CONFIG = {
  popupDuration: 5000, // milliseconds
  popupText: 'Email for my CV',
  defaultText: 'CV',
};

// Route Paths
export const ROUTES = {
  HOME: '/',
  PROJECTS: '/projects',
  RESUME: '/resume',
  EDUCATION: '/education',
  VOLUNTEERING: '/volunteering',
};

// Project Categories
export const PROJECT_CATEGORIES = {
  ALL: 'All',
  ML: 'ML',
  FULL_STACK: 'Full Stack',
  IOT: 'IoT',
  OTHER: 'Other',
};

// Skills Categories
export const SKILLS_CATEGORIES = ['Frontend', 'Languages', 'Backend', 'Software'];

// Error Messages
export const ERROR_MESSAGES = {
  IMAGE_LOAD_ERROR: 'Failed to load image',
  VIDEO_LOAD_ERROR: 'Failed to load video',
  GENERIC_ERROR: 'Something went wrong. Please try again later.',
  NETWORK_ERROR: 'Network error. Please check your connection.',
};

// Performance Configuration
export const PERFORMANCE = {
  IMAGE_LAZY_LOAD_THRESHOLD: 0.1,
  DEBOUNCE_DELAY: 300,
};

